import React , { Component } from "react";


class Download extends Component{
    render(){
        return(
            <div id="download" className={`download-area ${this.props.horizontal}`}>
                <div className="bg-overlay"/>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb--55 pt--50">  
                                <h2 className="text-white">DESCARGA <span className="theme-color">MAPPTRIX APP</span></h2>
                                <img src={require('../assets/images/app/title-icon-4.png')} alt="App Landing"/>
                                <p className="text-white">Lleva el poder del mapeo agrícola a tu dispositivo móvil. Descarga Mapptrix y gestiona tus campos desde cualquier lugar con tecnología GPS de precisión.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="download-buttons pb--50">
                                <button type="submit" className="download-btn">
                                    <i className="zmdi zmdi-apple"></i>
                                    <span>Disponible en <span className="large-text">App Store</span> </span>
                                </button>
                                <button type="submit" className="download-btn">
                                    <i className="zmdi zmdi-google-play"></i>
                                    <span>Disponible en <span className="large-text">Google Play</span> </span>
                                </button>
                                <button type="submit" className="download-btn">
                                    <i className="zmdi zmdi-windows"></i>
                                    <span>Disponible en <span className="large-text">Microsoft Store</span> </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Download;







